<template>
	<div class="container">
		<div class="m_sub_top">
			<div class="top_content">
				<h2 class="headline_m type2">
					{{ $t('rtr_personal-asset-jpys.text1') }}
				</h2>
				<p class="body_m">
					{{ $t('rtr_personal-asset-jpys.text2') }}<br />
					{{ $t('rtr_personal-asset-jpys.text3') }}
				</p>
				<div class="button_area">
					<button class="button_bg_red mr_10" @click="toLogin">
						{{ $t('button.signup') }}
					</button>
					<button class="button_bg_black" @click="notYet">
						{{ $t('button.down') }}
					</button>
				</div>
			</div>
		</div>
		<div class="bottom_area">
			<div class="bottom_box mb_16 pb_40">
				<h2 class="headline_s type2 mb_16">
					{{ $t('rtr_personal-asset-jpys.text4') }}
				</h2>
				<p class="body_m">
					{{ $t('rtr_personal-asset-jpys.text5') }}<br />
					{{ $t('rtr_personal-asset-jpys.text6') }}
				</p>
				<div class="icon_box">
					<div class="box1"></div>
					<div class="box2"></div>
				</div>
			</div>

			<div class="catch_box mb_16">
				<p class="title_l fc_white mb_16">
					{{ $t('rtr_personal-asset-jpys.text7') }}<br />
					{{ $t('rtr_personal-asset-jpys.text8') }}
				</p>
			</div>

			<div class="bottom_box second">
				<p class="title_m mb_16">{{ $t('rtr_personal-asset-jpys.text9') }}</p>
				<p class="body_m">
					{{ $t('rtr_personal-asset-jpys.text10') }}<br />
					{{ $t('rtr_personal-asset-jpys.text11') }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';

export default {
	name: 'Jpys.m',
	setup() {
		return {};
	},
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
<style scoped></style>
